import React from 'react';
import { useTranslation } from 'react-i18next';
import TaListReportPage from './components/TaListReportPage';
import { usePlanVsActual } from './config/planVsActual';

// AKM POC §7.4 — Plan–Gerçekleşen Sapma Raporu.
export default function PlanVsActualPage() {
  const { t } = useTranslation();
  const report = usePlanVsActual();
  return (
    <TaListReportPage
      title={t('taReports.planVsActual.title')}
      report={report}
      exportUrl="/v1/ta/reports/plan-vs-actual/export"
    />
  );
}
